import { createFileRoute, Navigate } from '@tanstack/react-router'
import { trpc } from '~/utils/trpc'
import { useAuth } from '~/lib/auth-context'
import { Loader2 } from 'lucide-react'
import { CompanySelector } from '~/components/employer/CompanySelector'

export const Route = createFileRoute('/$locale/employer/')({
  component: EmployerIndex,
})

function EmployerIndex() {
  const { locale } = Route.useParams()
  const { user } = useAuth()
  const companiesQuery = trpc.company.list.useQuery(undefined, {
    enabled: !!user,
  })

  if (companiesQuery.isLoading) {
    return (
      <div className="flex items-center justify-center py-24">
        <Loader2 className="h-6 w-6 animate-spin text-[#00f0ff]" />
      </div>
    )
  }

  const memberships = companiesQuery.data ?? []

  if (memberships.length === 0) {
    return <Navigate to="/$locale/employer/create" params={{ locale }} />
  }

  if (memberships.length === 1) {
    return (
      <Navigate
        to="/$locale/employer/$companyId"
        params={{ locale, companyId: memberships[0].company.id }}
      />
    )
  }

  return <CompanySelector memberships={memberships} locale={locale} />
}
